import React, { memo, useEffect, useState } from 'react';

import I18n from '@wetransfer/transfer/modules/i18n';

const FinalizingState = () => {
  const [stageIndex, setStageIndex] = useState(0);

  const stages = [
    I18n.t(`transfer.progress.title_finalizing_one`),
    I18n.t(`transfer.progress.title_finalizing_two`),
    I18n.t(`transfer.progress.title_finalizing_three`),
    I18n.t(`transfer.progress.title_finalizing_four`),
  ];

  useEffect(() => {
    let index = 0;

    const interval = setInterval(() => {
      index = index === 3 ? 0 : index + 1;

      setStageIndex(index);
    }, 3000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="transfer__finalize-container">
      <div className="transfer__finalize-animation">
        {stages.map((stage, i) => (
          <h2
            key={i}
            className={`transfer__finalize-title ${
              stageIndex === i ? 'transfer__finalize-title--visible' : ''
            }`}
          >
            {stage}
          </h2>
        ))}
      </div>
      <p className="transfer__finalize-subtitle">
        {I18n.t(`transfer.progress.subtitle_finalizing`)}.
      </p>
    </div>
  );
};

export default memo(FinalizingState);
